$shm_hitalama_settings $mol_book2
	title \Настройки
	pages /
		<= Main $mol_page
			title \Настройки
			body /
				<= Stick_label $mol_labeler
					title \Расстояние прилипания (px)
					Content <= Stick $mol_number
						Inc null
						Dec null
						value? <=> stick_px? 200
				<= Widget_float_resizer_size_label $mol_labeler
					title \Размер ресайзера виджета (px)
					Content <= Widget_float_resizer_size $mol_number
						Inc null
						Dec null
						value? <=> widget_float_resizer_size? 15
				<= Dragger_keep_size_label $mol_labeler
					title \Размер drag-иконки
					Content <= Dragger_keep_size $mol_check_box
						title \Фиксированный
						checked? <=> dragger_keep_size? true
				<= Widget_keyboard_move_step_label $mol_labeler
					title \Шаг перемещения виджетов стрелками (px)
					Content <= Widget_keyboard_move_step $mol_number
						Inc null
						Dec null
						value? <=> widget_keyboard_move_step_px? 1
				<= Agent_url_label $mol_labeler
					title \URL ИИ-агента
					Content <= Agent_url $shm_hitalama_settings_agent_string
						input_name \hitalama_agent_endpoint_manual
						value? <=> agent_url? \
				<= Agent_token_label $mol_labeler
					title \Токен ИИ-агента
					Content <= Agent_token $shm_hitalama_settings_agent_password
						input_name \hitalama_agent_secret_manual
						value? <=> agent_token? \
				<= Mic_label $mol_labeler
					title \Микрофон
					Content <= Mic $mol_select
						dictionary <= microphones *
						value? <=> mic? \
				<= Overlayed_map_controls $mol_view
					sub /
						<= Overlayed_map_enabled $mol_check_box
							checked? <=> overlayed_map_enabled? false
						<= Overlayed_map_link $mol_link
							title \Overlay-карта
							arg * settings \overlayed_map
				<= Templates_label $mol_labeler
					title \Шаблоны
					Content <= Templates_links $mol_view
						sub /
							<= Template_js_link $mol_link
								title \JS
								arg * settings \templates_js
							<= Template_tsx_link $mol_link
								title \TSX
								arg * settings \templates_tsx
							<= Template_sql_link $mol_link
								title \SQL
								arg * settings \templates_sql
							<= Template_commands_link $mol_link
								title \Команды
								arg * settings \templates_commands
				<= Maps_transfer_label $mol_labeler
					title \Резервная копия карт
					Content <= Maps_transfer $shm_hitalama_settings_transfer
				<= Hotkeys_link $mol_link
					title \Горячие клавиши
					arg * settings \hotkeys
				<= selfhosted_tauri_link
		<= spread_current
	Catalog $mol_book2_catalog
		param \settings
		spread_current => spread_current
		spreads *
			hotkeys <= Hotkeys $mol_page
				title \Горячие клавиши
				body /
					<= Slideshow_mode_label $mol_labeler
						title \Режим просмотра
						content /
							<= Slideshow_mode $mol_string
								value? <=> slideshow_mode_key? \
					<= Fullscreen_disable_label $mol_labeler
						title \Отключить fullscreen
						content /
							<= Fullscreen_disable $mol_string
								value? <=> fullscreen_disable_key? \Escape
					<= Drag_mode_label $mol_labeler
						title \Режим перетаскивания виджетов
						content /
							<= Drag_mode $mol_string
								value? <=> drag_mode_key? \Control
					<= Drawing_mode_label $mol_labeler
						title \Режим рисования
						content /
							<= Drawing_mode $mol_string
								value? <=> drawing_mode_key? \P
					- <= Next_slide_label $mol_labeler
						title \Следующий слайд
						content /
							<= Next_slide $mol_string
								value? <=> next_slide_key? \
			templates_js <= Templates_js $shm_hitalama_map_book
				entity <= template_map*js null
			templates_tsx <= Templates_tsx $shm_hitalama_map_book
				entity <= template_map*tsx
			templates_sql <= Templates_sql $shm_hitalama_map_book
				entity <= template_map*sql
			templates_commands <= Templates_commands $shm_hitalama_map_book
				entity <= template_map*commands
			overlayed_map <= Overlayed_map $shm_hitalama_map_book
				entity <= overlayed_map null
			selfhosted_tauri <= Selfhosted_tauri $mol_page
				title \Selfhosted Tauri
				body <= selfhosted_tauri_content /
	Selfhosted_tauri_config $mol_view
		sub <= selfhosted_tauri_config_content
	selfhosted_tauri_config_content /
		^ tauri_port_conflict_message_visible /
			<= Tauri_port_conflict_message $mol_text
				text <= tauri_port_conflict_message \
		<= Tauri_port_label $mol_labeler
			title \Порт
			Content <= Tauri_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_port? 9090
		<= Tauri_domain_label $mol_labeler
			title \Домен
			Content <= Tauri_domain $mol_string
				value? <=> tauri_domain? \
		<= Tauri_master_label $mol_labeler
			title \Master
			Content <= Tauri_master $mol_string
				value? <=> tauri_master? \
		<= Tauri_tunnel_enabled $mol_check_box
			title \SSH-туннель
			checked? <=> tauri_tunnel_enabled? false
		<= Tauri_ssh_host_label $mol_labeler
			title \SSH host
			Content <= Tauri_ssh_host $mol_string
				value? <=> tauri_ssh_host? \
		<= Tauri_ssh_user_label $mol_labeler
			title \SSH user
			Content <= Tauri_ssh_user $mol_string
				value? <=> tauri_ssh_user? \
		<= Tauri_ssh_port_label $mol_labeler
			title \SSH port
			Content <= Tauri_ssh_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_ssh_port? 22
		<= Tauri_remote_port_label $mol_labeler
			title \Remote port
			Content <= Tauri_remote_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_remote_port? 80
		<= Tauri_ssh_key_label $mol_labeler
			title \SSH key path
			Content <= Tauri_ssh_key $mol_string
				value? <=> tauri_ssh_key? \
		<= Tauri_save $mol_button_major
			title \Сохранить
			click? <=> tauri_save? null
		<= Tauri_save_message $mol_text
			text <= tauri_save_message? \
	Selfhosted_tauri_link $mol_link
		title \Selfhosted Tauri
		arg * settings \selfhosted_tauri
	selfhosted_tauri_link null

$shm_hitalama_settings_agent_string $mol_string
	autocomplete_locked? true
	input_name \hitalama_agent_manual
	field *
		^
		autocomplete \off
		readOnly <= autocomplete_locked? true
	attr *
		^
		autocomplete \off
		name <= input_name
		readonly <= autocomplete_locked? true
		aria-autocomplete \none
	event *
		^
		focus? <=> autocomplete_unlock? null

$shm_hitalama_settings_agent_password $mol_password
	input_name \hitalama_agent_secret_manual
	Pass $shm_hitalama_settings_agent_string
		type <= type
		hint <= hint \
		input_name <= input_name
		value? <=> value? \
		submit? <=> submit? null
		enabled <= enabled true
